import { render, staticRenderFns } from "./Status404.vue?vue&type=template&id=4542b56a"
import script from "./Status404.vue?vue&type=script&lang=js"
export * from "./Status404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports